import SummarizedReportGroupItem from './SummarizedReportGroupItem';

export enum GroupingTypes {
  ACCOUNT = 'ACCOUNT',
  BUYER = 'BUYER',
  CAMPAIGN = 'CAMPAIGN',
  DEAL = 'DEAL',
  DSP = 'DSP',
  UNIQUE_ADVERTISER = 'UNIQUE_ADVERTISER',
  LINE_ITEM = 'LINE_ITEM',
  MEDIA_OWNER = 'MEDIA_OWNER',
  MEDIA_TYPE = 'MEDIA_TYPE',
  NETWORK = 'NETWORK',
}

enum GroupingKeys {
  TOP_PAID_CPM = 'TOP_PAID_CPM',
  TOP_IMPRESSIONS = 'TOP_IMPRESSIONS',
  TOP_SPEND = 'TOP_SPEND',
  SPLIT_FOR_AD_SERVER = 'SPLIT_FOR_AD_SERVER',
  SPLIT_FOR_YIELD_MANAGER = 'SPLIT_FOR_YIELD_MANAGER',
  SPLIT_FOR_SSP = 'SPLIT_FOR_SSP',
  SPLIT_FOR_EXCHANGE = 'SPLIT_FOR_EXCHANGE',
}

// region API types

interface GroupingDataBaseApi {
  name: string;
  impressions: number;
  revenue: number;
  cpm: number;
  creative_ids?: Array<number>;
  revenue_percent?: number;
}

interface GroupingDataStandardApi extends GroupingDataBaseApi {
  id: number;
}

interface GroupingDataHBApi extends GroupingDataBaseApi {
  sspId: number;
}

type GroupingDataApi = GroupingDataStandardApi | GroupingDataHBApi;

export function isHeaderBidderGrouping(grouping): grouping is GroupingDataHBApi {
  return grouping.sspId != null;
}

export interface GroupingAPI {
  [GroupingKeys.TOP_PAID_CPM]: Array<GroupingDataApi>;
  [GroupingKeys.TOP_IMPRESSIONS]: Array<GroupingDataApi>;
  [GroupingKeys.TOP_SPEND]: Array<GroupingDataApi>;
  [GroupingKeys.SPLIT_FOR_YIELD_MANAGER]?: Array<GroupingDataApi>;
  [GroupingKeys.SPLIT_FOR_AD_SERVER]?: GroupingDataApi;
  [GroupingKeys.SPLIT_FOR_SSP]?: GroupingDataApi;
  [GroupingKeys.SPLIT_FOR_EXCHANGE]?: GroupingDataApi;
}

export type GroupingsAPI = Record<GroupingTypes, GroupingAPI>;

// endregion

// region Internal Types

export interface GroupingSplit {
  cpm: number;
  id: string;
  impressions: number;
  label: string;
  logoUri?: string;
  revenue: number;
  revenuePercent: number;
}

export interface Grouping {
  id: string;
  groupName: string;
  creativeIDs: number[];
  byImpressions: SummarizedReportGroupItem[];
  byPaidCPM: SummarizedReportGroupItem[];
  byRevenue: SummarizedReportGroupItem[];
  split?: GroupingSplit[];
  entityLinkRoute?: string;
}

// endregion
